import { render, staticRenderFns } from "./TAUsefulResources.vue?vue&type=template&id=44dbf726&"
import script from "./TAUsefulResources.vue?vue&type=script&lang=js&"
export * from "./TAUsefulResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports